import React from 'react';
import {
  Edit,
  NumberField,
  FunctionField,
  List,
  Datagrid,
  TextField,
  EditButton,
  SelectInput,
  DisabledInput,
  SimpleForm,
  Filter,
  ArrayInput,
  ArrayField,
  SimpleFormIterator,
  CardActions,
  Toolbar,
  SaveButton,
  ListButton,
  GET_LIST,
} from 'react-admin';
import Button from '@material-ui/core/Button';

import ArticlesListField from './ui/ArticlesListField';
import ArrayChipField from './ui/ArrayChipField';
import { DateInput } from 'react-admin-date-inputs';

import restClient from '../services/restClient';
import { appOptions } from '../config/app';

const Title = ({ record }) => {
  return <span>Site {record ? `"${record.id}"` : ''}</span>;
};

const sourceRowStyle = (record, index) => ({
  backgroundColor:
    record && (
    record.count === 0 ||
    (record.no_text && record.no_text.percent >= 20) ||
    (record.no_category && record.no_category.percent >= 20) ||
    (record.no_thumbnail && record.no_thumbnail.percent >= 20))
      ? '#FDF3F4'
      : 'white',
});

const MediasourceToolbar = props => (
  <Toolbar {...props} >
      <SaveButton />
  </Toolbar>
);

export const ArticlesReportList = props => (
  <List
    title="Articles Report"
    {...props}
    perPage={999}
    sort={{ field: 'count', order: 'desc' }}
    filters={<ArticlesReportFilter />}
    bulkActionButtons={false}
  >
    <Datagrid rowStyle={sourceRowStyle}>
      <FunctionField
        source="id"
        label=""
        render={(record, source) => record && <a href={'/#/mediasources/' + record['id']}>{record['id']}</a>}
      />
      <NumberField label="Articles" source="count" sortable={true} />
      <NumberField label="No text" source="no_text.count" sortable={true} />
      <NumberField label="No text %" source="no_text.percent" sortable={true} />
      <NumberField label="No category" source="no_category.count" sortable={true} />
      <NumberField label="No category %" source="no_category.percent" sortable={true} />
      <NumberField label="No thumbnail" source="no_thumbnail.count" sortable={true} />
      <NumberField label="No thumbnail %" source="no_thumbnail.percent" sortable={true} />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const ArticlesReportFilter = props => (
  <Filter {...props}>
    <DateInput label="From Date" source="fetch_date.gte" options={{ format: 'dd.MM.yyyy', clearable: true }} alwaysOn />
    <DateInput label="To Date" source="fetch_date.lte" options={{ format: 'dd.MM.yyyy', clearable: true }} alwaysOn />
  </Filter>
);

export class ArticlesReportDetails extends React.Component {
  state = {
    categories: [],
  };

  componentDidMount() {
    const apiClient = restClient(appOptions);
    apiClient(GET_LIST, 'articles/categories-choice').then(res => {
      this.setState({ categories: res.data});
    });
  }

  render () {
    const ArticlesReportDetailsActions = ({ basePath, data, resource }) => (
      <CardActions>
          <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
          <Button style={{marginRight: '10px'}} variant="outlined" color="primary" href={data && '/#/mediasources/' + data.id}>Edit</Button>
      </CardActions>
    );

    return (
      <Edit title={<Title />} actions={<ArticlesReportDetailsActions />} {...this.props}> 
        <SimpleForm toolbar={<MediasourceToolbar />}>
          <TextField source="count" label="Total Articles" />
          <FunctionField
            source="no_text"
            label="No text"
            render={(record, source) => (
              record &&
              <div className="report-details">
                {record['no_text'].count} ({record['no_text'].percent}%)<ArticlesListField
                  record={record['no_text']}
                />
              </div>
            )}
          />

          <FunctionField
            source="no_thumbnail"
            label="No thumbnail"
            render={(record, source) => (
              record &&
              <div className="report-details">
                {record['no_thumbnail'].count} ({record['no_thumbnail'].percent}%)<ArticlesListField
                  record={record['no_thumbnail']}
                />
              </div>
            )}
          />

          <FunctionField
            source="no_category"
            label="No category"
            render={(record, source) => (
              record &&
              <div className="report-details">
                {record['no_category'].count} ({record['no_category'].percent}%)
              </div>
            )}
          />

          <ArrayField  source={`categories`}>
            <Datagrid>
                <TextField source="name" />
                <TextField source="count" />
                <ArrayChipField source={`mappings`} />
            </Datagrid>
          </ArrayField >

          <ArrayInput source={`unmapped_categories`} className="inline-form">
            <SimpleFormIterator disableRemove disableAdd>
              <DisabledInput label="Source Category" source="name" />
              <DisabledInput label="Articles" source="count" />
              <SelectInput label="Target Category" source="ref" choices={this.state.categories} allowEmpty />
              <ArticlesListField />
            </SimpleFormIterator>
          </ArrayInput>
          
        </SimpleForm>
      </Edit>
    );
  }
};



// WEBPACK FOOTER //
// ./src/resources/articlesreport.js